'use client';

import { CSSProperties, FC } from 'react';
import { useTranslation } from '@/providers/app-provider/app-provider';

export interface RecipePreparationProps {
  steps: string[];
  stepsColor?: string;
  paddingStyle?: CSSProperties;
}

const RecipePreparationSteps: FC<RecipePreparationProps> = ({
  steps,
  stepsColor,
  paddingStyle,
}) => {
  const { t } = useTranslation();

  if (steps.length === 0) return null;

  return (
    <div className="container mx-auto" style={paddingStyle}>
      <h2 className="mb-4 text-lg font-semibold @md:text-xl">{t?.common.preparation}</h2>
      <ol className="flex flex-col gap-4">
        {steps.map((step, index) => (
          <li key={index} className="flex items-start gap-4">
            <span className="bg-primary flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white">
              {index + 1}
            </span>
            <p
              className="pt-1 text-sm @md:text-base"
              style={stepsColor ? { color: stepsColor } : undefined}
            >
              {step}
            </p>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default RecipePreparationSteps;
